const addHttpsProtocol = (url = '') => {
  const splittedUrl = url.split('://')

  const rest = splittedUrl?.[1] || splittedUrl?.[0] || ''

  return `https://${rest}`
}

const validUrl = (url = '') => {
  let re = /([-a-zA-Z0-9()@:%_+.~#?&//=]*)[-a-zA-Z0-9@:%_+~#=]{1,}\.[-a-zA-Z0-9@:%_+~#=]{1,}([-a-zA-Z0-9()@:%_+.~#?&//=]*)/gi
  if (!re.test(url)) return false

  const newUrl = addHttpsProtocol(url)

  let isValid = true
  try {
    isValid = new URL(newUrl)
    return true
  } catch (_) {
    return false
  }
}

const validWebUrl = (url = '') => {
  let re = /([-a-zA-Z0-9()@:%_+.~#?&//=]*)[-a-zA-Z0-9@:%_+~#=]{1,}\.[-a-zA-Z0-9@:%_+~#=]{1,}([-a-zA-Z0-9()@:%_+.~#?&//=]*)/gi
  if (!re.test(url)) return false

  const splittedUrl = url.split(':')

  if (splittedUrl.length > 1 && !['http', 'https'].includes(splittedUrl[0])) {
    return false
  }

  const newUrl = addHttpsProtocol(url)

  let isValid = true
  try {
    isValid = new URL(newUrl)
    return true
  } catch (_) {
    return false
  }
}

export default {
  addHttpsProtocol,
  validUrl,
  validWebUrl,
}

// https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)
// (https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)
